import { render, staticRenderFns } from "./NotFoundErrorPage.vue?vue&type=template&id=20c18f6d&scoped=true"
import script from "./NotFoundErrorPage.vue?vue&type=script&lang=js"
export * from "./NotFoundErrorPage.vue?vue&type=script&lang=js"
import style0 from "./NotFoundErrorPage.vue?vue&type=style&index=0&id=20c18f6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c18f6d",
  null
  
)

export default component.exports